'use client';

import { useState } from 'react';
import Image, { type StaticImageData } from 'next/image';

interface PartnerLogo {
  title: string;
  logo: StaticImageData;
}

interface PartnerMarqueeProps {
  logos: PartnerLogo[];
}

// Each logo owns a fixed width and right margin. A flex gap would make the
// second copy a different width, and the -50% loop would jump at the seam.
const copies = [
  { key: 'primary', isHidden: false },
  { key: 'clone', isHidden: true },
];

export const PartnerMarquee: React.FC<PartnerMarqueeProps> = ({ logos }) => {
  const [isPaused, setIsPaused] = useState(false);

  return (
    <>
      <div className="relative mt-10 w-screen overflow-hidden sm:mt-14">
        <div
          className="flex w-max items-center animate-partner-marquee motion-reduce:[animation-play-state:paused]"
          style={isPaused ? { animationPlayState: 'paused' } : undefined}
        >
          {copies.map((copy) => (
            <div
              key={copy.key}
              className="flex items-center"
              aria-hidden={copy.isHidden || undefined}
            >
              {logos.map((logo) => (
                <div key={logo.title} className="mr-12 flex w-32 items-center">
                  <Image
                    src={logo.logo}
                    alt={logo.title}
                    className="h-14 w-full object-contain brightness-0 invert"
                  />
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
      <button
        type="button"
        aria-pressed={isPaused}
        onClick={() => setIsPaused((current) => !current)}
        className="mt-4 text-sm text-white underline underline-offset-2"
      >
        {isPaused ? 'Play logos' : 'Pause logos'}
      </button>
    </>
  );
};
